import { ModelGroup, ModelItemAccessor } from '@mng/model';
import { createSvAngebotModel } from './svangebot.model';
import { SvAngebotDataItemAccessor } from '../svangebot.model.paths';

let svAngebotModel: ModelGroup;
let svAngebotModelItemAccessor: ModelItemAccessor;

export function getSvAngebotModel(): ModelGroup {
  if (!svAngebotModel) {
    svAngebotModel = createSvAngebotModel();
  }
  return svAngebotModel;
}

export function getSvAngebotModelItemAccessor(): ModelItemAccessor {
  if (!svAngebotModelItemAccessor) {
    svAngebotModelItemAccessor = new ModelItemAccessor(getSvAngebotModel());
  }
  return svAngebotModelItemAccessor;
}

export const svAngebotItemAccessor: SvAngebotDataItemAccessor = new SvAngebotDataItemAccessor(
  getSvAngebotModelItemAccessor()
);
